import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import useMoney from '../../../../../../../hooks/useMoney';
import { useTranslation } from '../../../../../../translation/TranslationContext';
import { BusinessPolicyViolationView } from '../businessPolicyViolation.types';
import {
  getCriterionLabel,
  getCriterionValueLabel,
  hasSingleCriterion,
  listViolatedCriteria,
} from '../businessPolicyViolation.utils';
import BusinessPolicyViolationDetailsLink from './BusinessPolicyViolationDetailsLink';
import BusinessPolicyViolationTitle from './BusinessPolicyViolationTitle';

interface BusinessPolicyViolationSummaryProps {
  violations: BusinessPolicyViolationView[];
  onOpenDetails?: () => void;
}

const BusinessPolicyViolationSummary = ({
  violations,
  onOpenDetails,
}: BusinessPolicyViolationSummaryProps) => {
  const { translate } = useTranslation();
  const { formatMoney } = useMoney();

  return (
    <Stack sx={{ gap: 1 }}>
      {violations.map((violation, index) => {
        const [criterion] = hasSingleCriterion(violation) ? listViolatedCriteria(violation) : [];

        return (
          <Stack key={`${violation.businessPolicy.id}-${violation.messageCode}`} sx={{ gap: 0.25 }}>
            <Typography
              variant="body2"
              color="inherit"
              noWrap
              title={translate(violation.messageCode, {
                expected: violation.businessPolicy.name,
              })}
            >
              {index + 1}.{' '}
              <BusinessPolicyViolationTitle
                messageCode={violation.messageCode}
                policyName={violation.businessPolicy.name}
              />
            </Typography>

            {criterion && (
              <Stack
                direction="row"
                sx={{ gap: 1.5, paddingLeft: 2, justifyContent: 'space-between' }}
              >
                <Typography variant="micro1" color="inherit">
                  {getCriterionLabel(criterion)}
                </Typography>
                <Typography
                  variant="micro1"
                  color="inherit"
                  sx={{ whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums' }}
                >
                  {getCriterionValueLabel(criterion, { translate, formatMoney })}
                </Typography>
              </Stack>
            )}
          </Stack>
        );
      })}

      {onOpenDetails && <BusinessPolicyViolationDetailsLink onOpenDetails={onOpenDetails} />}
    </Stack>
  );
};

export default BusinessPolicyViolationSummary;
